import { useOrganization } from '@clerk/clerk-react'

import { CAREFORCE_ORG_SLUG } from '@/config/constants'
import { useIsCareforceOrgAdmin } from '@/hooks/useIsCareforceOrgAdmin'
import { useIsSuperUser } from '@/hooks/useIsSuperUser'

/**
 * Who the caller is to the snippet library: the Careforce org itself, an
 * admin who may share, or a Careforce admin reading a customer org.
 */
export function useSnippetAccess() {
  const { organization } = useOrganization()
  const isCareforceOrg = organization?.slug === CAREFORCE_ORG_SLUG
  const canShare = useIsCareforceOrgAdmin()
  const isSuperUser = useIsSuperUser()
  return {
    isCareforceOrg,
    canShare,
    // A Careforce admin browsing a customer org is a reader there; the
    // read-only banner tells them where to edit instead.
    managedElsewhere: isSuperUser && !isCareforceOrg,
  }
}
